import type { ActionFunction } from '@remix-run/node';
import { json } from '@remix-run/node';

import type {
    UpdateCollaboratorMutation,
    UpdateCollaboratorMutationVariables,
} from 'generated/graphql';
import { UpdateCollaboratorDocument } from 'generated/graphql';
import invariant from 'tiny-invariant';

export const UPDATE_BUILD_HUB_COLLABORATOR_API_ROUTE =
    '/remix-api/app/build-hub-collaborator-update';

const DEFAULT_FAILED_MESSAGE = 'Failed to update BuildHub collaborator.';

export const action: ActionFunction = async ({ request, context }) => {
    const data = await request.formData();

    invariant(data.get('buildHubId'), 'No BuildHub ID provided for update.');
    invariant(
        data.get('collaboratorId'),
        'No Collaborator ID provided for update.'
    );
    invariant(data.get('role'), 'No Collaborator Role provided for update.');

    const caption = data.get('caption');

    let variables: UpdateCollaboratorMutationVariables = {
        BuildHubID: data.get('buildHubId') as string,
        CollaboratorID: data.get('collaboratorId') as string,
        Role: data.get('role') as string,
        ...(caption !== null && { Caption: caption as string }),
    };

    try {
        const { data: result } = await context.client.mutate<
            UpdateCollaboratorMutation,
            UpdateCollaboratorMutationVariables
        >({
            mutation: UpdateCollaboratorDocument,
            variables,
        });

        const validResult = result?.buildHubCollaboratorUpdate;
        if (!validResult) {
            return json({
                buildHubUpsert: {
                    __typename: 'ServerError',
                    Message: DEFAULT_FAILED_MESSAGE,
                },
            });
        }

        return json(result);
    } catch (error) {
        return json({
            buildHubUpsert: {
                __typename: 'ServerError',
                Message:
                    error instanceof Error
                        ? error.message
                        : DEFAULT_FAILED_MESSAGE,
            },
        });
    }
};
